export default __webpack_public_path__ + "static/media/Related_Party_Transaction_Policy_2.351099cd.pdf";